const DEFAULT_LOREM_IPSUM =
  'Lorem ipsum dolor sit amet consectetur adipiscing elit Donec a diam vel ex volutpat molestie eget at nisl Aenean convallis sodales vestibulum Duis sed odio tortor Quisque et sapien laoreet';

export function generateLoremIpsum(
  wordCount: number,
  capitaliseFirstLetter: boolean = true,
  sourceText: string = DEFAULT_LOREM_IPSUM,
): string {
  let words = sourceText.split(/(\s+)/).filter((word) => word !== ' ');

  if (words.length < wordCount) {
    let duplicatedWords = [...words];

    while (duplicatedWords.length < wordCount) {
      duplicatedWords = duplicatedWords.concat(words);
    }
    words = duplicatedWords;
  }

  // Shuffle the array of words
  for (let i = words.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [words[i], words[j]] = [words[j], words[i]];
  }

  const loremIpsum = words.slice(0, wordCount).join(' ');

  return capitaliseFirstLetter ? loremIpsum.charAt(0).toUpperCase() + loremIpsum.slice(1) : loremIpsum;
}